// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__wideContainer___LHQtI {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: var(--header-height);
    padding: 0 var(--container-padding-horizontal);
    box-sizing: border-box;
    background-color: var(--grey-lightest);
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0);
    transition: box-shadow 0.3s;
}

.styles__sticky___OWrZ0 {
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
}

.styles__container___ViIly {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: var(--mobile-page-width);
    padding: 0 70px 0 70px;
    margin: 0 auto;
    box-sizing: border-box;
}

.styles__container___ViIly a {
    position: absolute;
    top: 50%;
    left: 0;
    display: inline-block;
    width: 40px;
    height: 40px;
    transform: translateY(-50%);
}

.styles__container___ViIly a img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 10px;
}

.styles__mainTitle___rSPLZ {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: var(--main-title-font-size-mobile);
    margin: 0;
    text-align: center;
    color: var(--text);
}

@media screen and (min-width: 768px) {
    .styles__container___ViIly {
        max-width: var(--tablets-page-width);
    }

    .styles__mainTitle___rSPLZ {
        font-size: var(--main-title-font-size-tablet);
    }
}

@media screen and (min-width: 1024px) {
    .styles__container___ViIly {
        max-width: var(--desktop-page-width);
    }

    .styles__mainTitle___rSPLZ {
        font-size: var(--main-title-font-size-desktop);
    }
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/Header/styles.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,8CAA8C;IAC9C,sBAAsB;IACtB,sCAAsC;IACtC,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,6CAA6C;IAC7C,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,oCAAoC;IACxC;;IAEA;QACI,6CAA6C;IACjD;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;;IAEA;QACI,8CAA8C;IAClD;AACJ","sourcesContent":["@import \"../../styles/variables.css\";\n\n.wideContainer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: var(--header-height);\n    padding: 0 var(--container-padding-horizontal);\n    box-sizing: border-box;\n    background-color: var(--grey-lightest);\n    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0);\n    transition: box-shadow 0.3s;\n}\n\n.sticky {\n    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);\n}\n\n.container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    max-width: var(--mobile-page-width);\n    padding: 0 70px 0 70px;\n    margin: 0 auto;\n    box-sizing: border-box;\n}\n\n.container a {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    transform: translateY(-50%);\n}\n\n.container a img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n}\n\n.mainTitle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    font-size: var(--main-title-font-size-mobile);\n    margin: 0;\n    text-align: center;\n    color: var(--text);\n}\n\n@media screen and (min-width: 768px) {\n    .container {\n        max-width: var(--tablets-page-width);\n    }\n\n    .mainTitle {\n        font-size: var(--main-title-font-size-tablet);\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .container {\n        max-width: var(--desktop-page-width);\n    }\n\n    .mainTitle {\n        font-size: var(--main-title-font-size-desktop);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wideContainer": `styles__wideContainer___LHQtI`,
	"sticky": `styles__sticky___OWrZ0`,
	"container": `styles__container___ViIly`,
	"mainTitle": `styles__mainTitle___rSPLZ`
};
export default ___CSS_LOADER_EXPORT___;
